/**
 * IntelliGems A/B Test: Circular UGC review videos (under ATC)
 *
 * Control (A): data-circular-ugc-videos="false"
 * Variant (B): data-circular-ugc-videos="true"
 *
 * Pulls video reviews from Ryviu and renders Instagram-style circular
 * thumbnails under the Add to Cart button. Click opens a popup player.
 *
 * Dev preview: ?circular_ugc_videos_test=b
 */
(function () {
  'use strict';

  if (window.__circularUgcVideosABTestInit) return;
  window.__circularUgcVideosABTestInit = true;

  var BODY_ATTR = 'data-circular-ugc-videos';
  var ROOT_ATTR = 'data-circular-ugc-root';
  var MARK_ATTR = 'data-circular-ugc-injected';
  var MODAL_ID = 'circular-ugc-videos-ab-modal';
  var MAX_ITEMS = 10;
  var MIN_ITEMS = 6; /* 4 uploaded UGC + 2 website videos */
  var applying = false;
  var debounceTimer = null;
  var fetchStarted = false;
  var fetchPromise = null;
  var stories = [];
  var hostedRoot = null;
  var modalEl = null;
  var currentIndex = 0;
  var lastFocused = null;
  var placedOnce = false;
  var variantActive = null;
  var injectRetries = 0;

  var PLAY_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M8 5.5v13l11-6.5L8 5.5z" fill="currentColor"></path>' +
    '</svg>';

  var CLOSE_ICON =
    '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M4.5 4.5l9 9M13.5 4.5l-9 9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
    '</svg>';

  /* Local-shop supplement handles (may differ per market store) */
  var SUPPLEMENT_HANDLES = [
    'pawfect-double-sided-lint-remover',
    'fluff-away-double-sided-hair-sweeper-brush',
    'coastal-velvet-shell-cushion-cover',
    'modern-maple-leaf-couch-cover',
    'luxury-refillable-bottle-for-bathrooms',
    'rustic-floral-tassel-breathable-blanket'
  ];

  /*
   * Brand Ryviu account (AU / shared catalog) — INT store f88f27-b3 often has
   * photo reviews only, so we pull real customer video reviews from here.
   */
  var BRAND_RYVIU_DOMAIN = 'casa-beyond.myshopify.com';
  var BRAND_VIDEO_SOURCES = [
    { handle: 'fluff-away-double-sided-hair-sweeper-brush', productId: 9712656744734 },
    { handle: 'coastal-velvet-shell-cushion-cover', productId: 0 },
    { handle: 'luxury-refillable-bottle-for-bathrooms', productId: 0 },
    { handle: 'modern-maple-leaf-couch-cover', productId: 0 }
  ];

  /*
   * Primary 4 UGC mp4s (set from theme.liquid via window.__circularUgcPrimaryVideos)
   * + 2 website videos always appended at the end.
   */
  var PRIMARY_UGC = Array.isArray(window.__circularUgcPrimaryVideos)
    ? window.__circularUgcPrimaryVideos
    : [];

  var STORE_UGC_TAIL = [
    {
      id: 'site-aff689e0e07346d3947312a52a85a298',
      name: 'Customer',
      url: 'https://cdn.shopify.com/videos/c/o/v/aff689e0e07346d3947312a52a85a298.mp4'
    },
    {
      id: 'site-868009bf030745bfa93cd6c984e66596',
      name: 'Customer',
      url: 'https://cdn.shopify.com/videos/c/o/v/868009bf030745bfa93cd6c984e66596.mp4'
    }
  ];

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('circular_ugc_videos_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;
    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function isProductPage() {
    if (!document.body) return false;
    if (document.body.classList.contains('template-product')) return true;
    if (window.theme && window.theme.pageType === 'product') return true;
    return /\/products\//.test(window.location.pathname);
  }

  function getShopDomain() {
    if (window.Shopify && Shopify.shop) return Shopify.shop;
    return window.location.hostname;
  }

  function getProductMeta() {
    var handle = '';
    var productId = '';

    try {
      var pathMatch = window.location.pathname.match(/\/products\/([^\/\?\#]+)/);
      if (pathMatch) handle = decodeURIComponent(pathMatch[1]);
    } catch (e) {}

    var widget = document.querySelector(
      '.r--widget-section ryviu-widget, ryviu-widget:not([collection]):not([feature]), ryviu-widget-total:not([collection])'
    );
    if (widget) {
      handle = handle || widget.getAttribute('handle') || '';
      productId = productId || widget.getAttribute('product_id') || '';
    }

    if (!productId) {
      var metaId =
        document.querySelector('meta[property="product:id"]') ||
        document.querySelector('[data-product-id]');
      if (metaId) {
        productId =
          metaId.getAttribute('content') ||
          metaId.getAttribute('data-product-id') ||
          '';
      }
    }

    if (window.meta && window.meta.product) {
      productId = productId || String(window.meta.product.id || '');
      handle = handle || window.meta.product.handle || '';
    }

    return { handle: handle, productId: productId };
  }

  function normalizeReviewerName(raw) {
    var text = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!text) return 'Customer';
    text = text.replace(/\*+/g, '').trim();
    var first = text.split(/[\s,|\/]+/)[0] || 'Customer';
    if (first.length < 2) return 'Customer';
    return first.charAt(0).toUpperCase() + first.slice(1);
  }

  function streamBaseFromUrl(url, id) {
    var raw = String(url || '');
    if (id && /cloudflarestream\.com/i.test(raw)) {
      var m = raw.match(/^(https?:\/\/[^\/]+\/[a-f0-9]+)/i);
      if (m) return m[1];
      return 'https://customer-ssyf3pe7roqm47m5.cloudflarestream.com/' + id;
    }
    if (id) return 'https://customer-ssyf3pe7roqm47m5.cloudflarestream.com/' + id;
    return '';
  }

  function normalizeVideo(video, review) {
    if (!video) return null;

    var author = normalizeReviewerName(
      (review && (review.author || review.user_name || review.name || review.customer_name)) || 'Customer'
    );
    var photo =
      (review && Array.isArray(review.body_urls) && review.body_urls[0]) ||
      (review && review.avatar) ||
      '';

    if (typeof video === 'string') {
      var str = video.trim();
      if (!str) return null;
      var strIdMatch = str.match(/cloudflarestream\.com\/([a-f0-9]+)/i);
      var strId = strIdMatch ? strIdMatch[1] : '';
      var strBase = streamBaseFromUrl(str, strId);
      return {
        id: strId || str,
        name: author,
        url: str,
        poster: photo || (strBase ? strBase + '/thumbnails/thumbnail.jpg?time=1s&height=240' : ''),
        embed: strBase ? strBase + '/iframe?autoplay=true&muted=false' : '',
        isHls: /\.m3u8(\?|$)/i.test(str)
      };
    }

    if (typeof video === 'object') {
      var id = String(video.id || video.video_id || '').trim();
      var url = String(video.url || video.src || video.mp4 || '').trim();
      if (!id && !url) return null;
      var base = streamBaseFromUrl(url, id);
      return {
        id: id || url,
        name: author,
        url: url || (base ? base + '/manifest/video.m3u8' : ''),
        poster: photo || (base ? base + '/thumbnails/thumbnail.jpg?time=1s&height=240' : ''),
        embed: base ? base + '/iframe?autoplay=true&muted=false' : '',
        isHls: /\.m3u8(\?|$)/i.test(url)
      };
    }

    return null;
  }

  function reviewsFromPayload(data) {
    if (!data) return [];
    if (Array.isArray(data.more_reviews)) return data.more_reviews;
    if (Array.isArray(data.reviews)) return data.reviews;
    if (data.reviews && Array.isArray(data.reviews.data)) return data.reviews.data;
    if (data.reviews && Array.isArray(data.reviews.reviews)) return data.reviews.reviews;
    if (Array.isArray(data.data)) return data.data;
    return [];
  }

  function collectFromReviews(reviews, bag, seen) {
    if (!Array.isArray(reviews)) return;
    for (var i = 0; i < reviews.length; i++) {
      var story = normalizeVideo(reviews[i] && reviews[i].video, reviews[i]);
      if (!story || !story.url) continue;
      if (seen[story.id]) continue;
      seen[story.id] = true;
      bag.push(story);
      if (bag.length >= MAX_ITEMS) return;
    }
  }

  function fetchRyviuPage(handle, productId, page, filter, domainOverride) {
    var domain = domainOverride || getShopDomain();
    var body = JSON.stringify({
      handle: handle || '',
      domain: domain,
      product_id: productId ? Number(productId) || productId : 0,
      platform: 'shopify',
      page: page || 1,
      type: 'load-more',
      order: 'late',
      filter: filter || 'all',
      first_load: page === 1,
      locale: document.documentElement.lang || 'en'
    });

    return fetch(
      'https://app.ryviu.io/frontend/client/get-more-reviews?domain=' + encodeURIComponent(domain),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }
    ).then(function (res) {
      return res.json();
    });
  }

  function pushMp4Story(bag, seen, item) {
    if (!item || !item.url || seen[item.id]) return;
    seen[item.id] = true;
    bag.push({
      id: item.id,
      name: item.name || 'Customer',
      url: item.url,
      poster: item.poster || '',
      embed: '',
      isHls: false,
      landscape: true
    });
  }

  function appendPrimaryUgc(bag, seen) {
    for (var i = 0; i < PRIMARY_UGC.length; i++) {
      pushMp4Story(bag, seen, PRIMARY_UGC[i]);
      if (bag.length >= MAX_ITEMS) return;
    }
  }

  function appendWebsiteTail(bag, seen) {
    for (var i = 0; i < STORE_UGC_TAIL.length; i++) {
      pushMp4Story(bag, seen, STORE_UGC_TAIL[i]);
      if (bag.length >= MAX_ITEMS) return;
    }
  }

  function scrapeDomVideos(bag, seen) {
    var nodes = document.querySelectorAll(
      '.r--widget-section video source, .r--widget-section video, ryviu-widget video source, ryviu-widget video, [data-ryviu-video], .ryviu-video video'
    );

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var url =
        node.getAttribute('src') ||
        node.getAttribute('data-src') ||
        node.getAttribute('data-ryviu-video') ||
        '';
      if (!url) continue;
      var fakeReview = {
        author: 'Customer',
        body_urls: [node.getAttribute('poster') || '']
      };
      var story = normalizeVideo(url, fakeReview);
      if (!story || seen[story.id]) continue;
      seen[story.id] = true;
      bag.push(story);
      if (bag.length >= MAX_ITEMS) return;
    }
  }

  function loadStories(force) {
    if (!force && stories.length) return Promise.resolve(stories);
    if (!force && fetchPromise) return fetchPromise;

    fetchStarted = true;

    /* Re-read liquid-injected URLs in case script order varies */
    if (Array.isArray(window.__circularUgcPrimaryVideos) && window.__circularUgcPrimaryVideos.length) {
      PRIMARY_UGC = window.__circularUgcPrimaryVideos;
    }

    var bag = [];
    var seen = {};

    appendPrimaryUgc(bag, seen);
    appendWebsiteTail(bag, seen);

    stories = bag.slice(0, MAX_ITEMS);
    if (stories.length < MIN_ITEMS) {
      fetchStarted = false;
      fetchPromise = null;
    } else {
      fetchPromise = Promise.resolve(stories);
    }
    return Promise.resolve(stories);
  }

  function isVisibleEl(el) {
    if (!el || !el.isConnected) return false;
    try {
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      var rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    } catch (e) {
      return true;
    }
  }

  function queryAll(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function findMainAtcWrap() {
    var shipped = document.querySelector('[data-shipped-today-root]');
    if (shipped) {
      var prev = shipped.previousElementSibling;
      while (prev) {
        if (
          prev.matches &&
          (prev.matches('.ProductForm__BuyButtons, .product-form__buttons, gp-product-button, .gp-button-atc') ||
            prev.querySelector('.ProductForm__AddToCart, .gp-button-atc, [data-action="add-to-cart"], button[name="add"]'))
        ) {
          return prev;
        }
        prev = prev.previousElementSibling;
      }
      if (shipped.parentNode) return shipped;
    }

    var atcCandidates = queryAll(
      '.ProductForm__AddToCart, .gp-button-atc, button[name="add"], [data-action="add-to-cart"], [aria-label="Add to cart"], [aria-label="Add to Cart"], gp-product-button button[type="submit"]'
    );

    for (var i = 0; i < atcCandidates.length; i++) {
      var atc = atcCandidates[i];
      if (!isVisibleEl(atc)) continue;
      var wrap =
        atc.closest('.ProductForm__BuyButtons, .product-form__buttons, gp-product-button, gp-button') ||
        atc;
      if (wrap && wrap.parentNode) return wrap;
    }

    var buyButtons = queryAll('.ProductForm__BuyButtons, .product-form__buttons, gp-product-button');
    for (var j = 0; j < buyButtons.length; j++) {
      if (isVisibleEl(buyButtons[j])) return buyButtons[j];
    }

    return buyButtons[0] || null;
  }

  function placeRoot(node) {
    if (!node) return false;

    /* Preferred: directly under ATC, above the shipped-today / geo shipping row */
    var beforeTargets = [
      '[data-shipped-today-root]',
      '#geo-ship-badge',
      '.geo-ship',
      '.custom-shipping-container',
      '.htusb-placeholder-stock'
    ];

    for (var i = 0; i < beforeTargets.length; i++) {
      var target = document.querySelector(beforeTargets[i]);
      if (!target || !target.parentNode) continue;
      if (target.closest && target.closest('[' + ROOT_ATTR + ']')) continue;
      if (!isVisibleEl(target) && beforeTargets[i] !== '[data-shipped-today-root]') continue;
      target.parentNode.insertBefore(node, target);
      return true;
    }

    var anchor = findMainAtcWrap();
    if (!anchor || !anchor.parentNode) return false;

    /* If anchor is shipped-today itself, insert before it */
    if (anchor.hasAttribute && anchor.hasAttribute('data-shipped-today-root')) {
      anchor.parentNode.insertBefore(node, anchor);
      return true;
    }

    if (anchor.nextSibling) anchor.parentNode.insertBefore(node, anchor.nextSibling);
    else anchor.parentNode.appendChild(node);
    return true;
  }

  function buildRootHtml() {
    var html =
      '<div class="circular-ugc-videos-ab__list" role="list" aria-label="Customer video reviews">';

    for (var i = 0; i < stories.length; i++) {
      var story = stories[i];
      /* Same mp4 as popup — muted loop preview in the circle */
      var preview =
        '<video class="circular-ugc-videos-ab__preview" src="' +
        escapeAttr(story.url) +
        '" muted playsinline autoplay loop preload="metadata" tabindex="-1" aria-hidden="true"></video>';

      html +=
        '<button type="button" class="circular-ugc-videos-ab__item" role="listitem" data-circular-ugc-open="' +
        i +
        '" aria-label="Play video from ' +
        escapeAttr(story.name) +
        '">' +
        '<span class="circular-ugc-videos-ab__ring">' +
        preview +
        '<span class="circular-ugc-videos-ab__play" aria-hidden="true">' +
        PLAY_ICON +
        '</span>' +
        '</span>' +
        '</button>';
    }

    html += '</div>';
    return html;
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function playCirclePreviews(root) {
    if (!root) return;
    var videos = root.querySelectorAll('video.circular-ugc-videos-ab__preview');
    for (var i = 0; i < videos.length; i++) {
      try {
        videos[i].muted = true;
        var playPromise = videos[i].play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } catch (e) {}
    }
  }

  function createRoot() {
    var root = document.createElement('div');
    root.className = 'circular-ugc-videos-ab';
    root.setAttribute(ROOT_ATTR, '');
    root.setAttribute(MARK_ATTR, 'true');
    root.innerHTML = buildRootHtml();
    return root;
  }

  function ensureModal() {
    if (modalEl && document.body.contains(modalEl)) return modalEl;

    modalEl = document.createElement('div');
    modalEl.id = MODAL_ID;
    modalEl.className = 'circular-ugc-videos-ab-modal';
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="circular-ugc-videos-ab-modal__backdrop" data-circular-ugc-close></div>' +
      '<div class="circular-ugc-videos-ab-modal__dialog" role="dialog" aria-modal="true" aria-label="Customer video" tabindex="-1">' +
      '<div class="circular-ugc-videos-ab-modal__top">' +
      '<p class="circular-ugc-videos-ab-modal__name" data-circular-ugc-name></p>' +
      '<button type="button" class="circular-ugc-videos-ab-modal__close" data-circular-ugc-close aria-label="Close">' +
      CLOSE_ICON +
      '</button>' +
      '</div>' +
      '<div class="circular-ugc-videos-ab-modal__media" data-circular-ugc-media></div>' +
      '<button type="button" class="circular-ugc-videos-ab-modal__hit circular-ugc-videos-ab-modal__hit--prev" data-circular-ugc-prev aria-label="Previous video"></button>' +
      '<button type="button" class="circular-ugc-videos-ab-modal__hit circular-ugc-videos-ab-modal__hit--next" data-circular-ugc-next aria-label="Next video"></button>' +
      '</div>';

    document.body.appendChild(modalEl);
    return modalEl;
  }

  function clearMedia(media) {
    if (!media) return;
    var iframe = media.querySelector('iframe');
    var video = media.querySelector('video');
    if (iframe) iframe.src = 'about:blank';
    if (video) {
      try {
        video.pause();
        video.removeAttribute('src');
        video.load();
      } catch (e) {}
    }
    media.innerHTML = '';
  }

  function openModal(index) {
    if (!stories.length) return;
    currentIndex = ((index % stories.length) + stories.length) % stories.length;
    var story = stories[currentIndex];
    var modal = ensureModal();
    var nameEl = modal.querySelector('[data-circular-ugc-name]');
    var media = modal.querySelector('[data-circular-ugc-media]');
    var dialog = modal.querySelector('.circular-ugc-videos-ab-modal__dialog');

    lastFocused = document.activeElement;
    if (nameEl) nameEl.textContent = story.name || 'Customer';
    clearMedia(media);

    if (dialog) {
      dialog.classList.remove('circular-ugc-videos-ab-modal__dialog--instagram');
      dialog.classList.add('circular-ugc-videos-ab-modal__dialog--landscape');
    }

    /* Same file as circle preview — autoplay with sound controls */
    media.innerHTML =
      '<video class="circular-ugc-videos-ab-modal__video" src="' +
      escapeAttr(story.url) +
      '" controls playsinline autoplay></video>';

    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('circular-ugc-videos-ab-modal-open');

    var item = hostedRoot && hostedRoot.querySelector('[data-circular-ugc-open="' + currentIndex + '"]');
    if (item) item.classList.add('is-seen');

    if (dialog) dialog.focus();
  }

  function closeModal() {
    if (!modalEl) return;
    var media = modalEl.querySelector('[data-circular-ugc-media]');
    clearMedia(media);
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('circular-ugc-videos-ab-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try {
        lastFocused.focus();
      } catch (e) {}
    }
  }

  function nextStory() {
    if (currentIndex >= stories.length - 1) {
      closeModal();
      return;
    }
    openModal(currentIndex + 1);
  }

  function prevStory() {
    if (currentIndex <= 0) {
      openModal(0);
      return;
    }
    openModal(currentIndex - 1);
  }

  function removeHosted() {
    applying = true;
    try {
      if (hostedRoot && hostedRoot.parentNode) {
        hostedRoot.parentNode.removeChild(hostedRoot);
      }
      hostedRoot = null;

      var leftovers = document.querySelectorAll('[' + ROOT_ATTR + ']');
      for (var i = 0; i < leftovers.length; i++) {
        if (leftovers[i].parentNode) leftovers[i].parentNode.removeChild(leftovers[i]);
      }
      placedOnce = false;
      injectRetries = 0;
    } finally {
      applying = false;
    }
  }

  function syncInjection() {
    if (!isProductPage() || !isVariantB()) {
      removeHosted();
      return;
    }

    if (!stories.length || stories.length < MIN_ITEMS) {
      removeHosted();
      return;
    }

    var existing = document.querySelector('[' + ROOT_ATTR + ']');
    if (existing && existing.isConnected) {
      hostedRoot = existing;
      placedOnce = true;
      return;
    }

    /* Already placed once this page — don't thrash the DOM */
    if (placedOnce && injectRetries > 8) return;

    applying = true;
    try {
      hostedRoot = createRoot();
      if (placeRoot(hostedRoot)) {
        placedOnce = true;
        injectRetries = 0;
        playCirclePreviews(hostedRoot);
      } else {
        if (hostedRoot.parentNode) hostedRoot.parentNode.removeChild(hostedRoot);
        hostedRoot = null;
        injectRetries += 1;
      }
    } finally {
      applying = false;
    }
  }

  function applyVariant() {
    if (applying) return;

    var variantB = isVariantB() && isProductPage();

    /* Skip if nothing changed and slider already placed (or control stays control) */
    if (variantB === variantActive) {
      if (!variantB) return;
      if (placedOnce && hostedRoot && hostedRoot.isConnected) return;
    }

    variantActive = variantB;
    document.documentElement.classList.toggle('circular-ugc-videos-b', !!variantB);

    if (!variantB) {
      removeHosted();
      closeModal();
      return;
    }

    loadStories(false).then(function () {
      if (!isVariantB() || !isProductPage()) return;
      syncInjection();
    });
  }

  function scheduleApply() {
    if (applying) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 120);
  }

  function onDocumentClick(event) {
    var openBtn = event.target.closest && event.target.closest('[data-circular-ugc-open]');
    if (openBtn) {
      event.preventDefault();
      openModal(parseInt(openBtn.getAttribute('data-circular-ugc-open'), 10) || 0);
      return;
    }

    if (event.target.closest && event.target.closest('[data-circular-ugc-close]')) {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.target.closest && event.target.closest('[data-circular-ugc-prev]')) {
      event.preventDefault();
      prevStory();
      return;
    }

    if (event.target.closest && event.target.closest('[data-circular-ugc-next]')) {
      event.preventDefault();
      nextStory();
    }
  }

  function onKeydown(event) {
    if (!modalEl || modalEl.getAttribute('data-open') !== 'true') return;
    if (event.key === 'Escape') closeModal();
    if (event.key === 'ArrowRight') nextStory();
    if (event.key === 'ArrowLeft') prevStory();
  }

  function observeAttrTarget(target) {
    if (!target) return;
    new MutationObserver(function (mutations) {
      if (applying) return;
      for (var i = 0; i < mutations.length; i++) {
        var name = mutations[i].attributeName;
        if (
          name === BODY_ATTR ||
          name === 'data-gem-variant' ||
          name === 'data-gem-test-active'
        ) {
          variantActive = null;
          placedOnce = false;
          scheduleApply();
          return;
        }
      }
    }).observe(target, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    /* Late ATC / shipped-today mount — limited retries only, no childList observer */
    var tries = 0;
    var wait = setInterval(function () {
      tries += 1;
      if (!isVariantB() || !isProductPage()) {
        if (tries > 24) clearInterval(wait);
        return;
      }
      if (hostedRoot && hostedRoot.isConnected) {
        clearInterval(wait);
        return;
      }
      if (stories.length) syncInjection();
      else loadStories(false).then(syncInjection);
      if (tries > 24) clearInterval(wait);
    }, 400);

    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);

    observeAttrTarget(document.body);
    observeAttrTarget(document.documentElement);

    document.addEventListener('gem:variant:changed', function () {
      variantActive = null;
      placedOnce = false;
      scheduleApply();
    });
  }

  window.CircularUgcVideosABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      fetchStarted = false;
      fetchPromise = null;
      variantActive = null;
      placedOnce = false;
      applyVariant();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      variantActive = null;
      applyVariant();
    },
    isActive: isVariantB,
    open: openModal,
    close: closeModal,
    getStories: function () {
      return stories.slice();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
